import React, { FC, useMemo } from "react";
import programMenuData from "@/data/program-menu-data.json";
import styles from "./program-search-results.module.scss";
import Link from "next/link";
interface Program {
  url: string;
  Title: string;
}
interface ProgramSearchResultsProps {
  searchValue: string;
}

const ProgramSearchResults: FC<ProgramSearchResultsProps> = ({
  searchValue,
}) => {
  const { MAIN_LIST } = programMenuData;

  const filteredProgramData = useMemo(() => {
    const query = searchValue.toLowerCase().trim();
    if (!query) return [];

    return MAIN_LIST.filter((program: Program) =>
      program.Title.toLowerCase().includes(query)
    );
  }, [searchValue]);

  if (!searchValue) {
    return null;
  }

  return (
    <div
      className={`${styles.resultsWrapper} ${!!searchValue ? styles.open : ""}`}
      aria-live="polite"
    >
      {filteredProgramData.length > 0 ? (
        filteredProgramData.map((program: Program) => (
          <Link
            className={styles.programItem}
            key={program.url}
            title={program.Title}
            href={`/${program.url}`}
            aria-label={`Go to ${program.Title}`}
          >
            {program.Title}
          </Link>
        ))
      ) : (
        <div className={styles.noResults} role="alert">
          No results found
        </div>
      )}
    </div>
  );
};

export default React.memo(ProgramSearchResults);
